import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from 'shared/components/Tooltip';
import styles from './Hint.module.scss';

const Hint = ({ iconClassName, tooltip, position, children, className, tooltipClassName }) => (
  <Tooltip content={tooltip} spanClassName={tooltipClassName}>
    {children ? (
      <div className={styles.childrenWrap}>
        {children}
        <i className={cn(styles.icon, styles[position], iconClassName, className)} />
      </div>
    ) : (
      <i className={cn(styles.icon, styles[position], iconClassName, className)} />
    )}
  </Tooltip>
);

Hint.propTypes = {
  iconClassName: PropTypes.string.isRequired,
  className: PropTypes.string,
  tooltipClassName: PropTypes.string,
  tooltip: PropTypes.node.isRequired,
  children: PropTypes.node,
  position: PropTypes.oneOf(['left', 'right']),
};

Hint.defaultProps = {
  children: null,
  position: 'right',
  className: null,
  tooltipClassName: null,
};

export default Hint;
